// The editor is embedded in an iframe by a host LMS shell. In this codebase
// that host is normally aidea.console, whose per-environment origin is baked
// in at build time as APP_BASE_URL (see webpack.dev.js / webpack.prod.js and
// .env*). Third-party integrators embedding the editor from a different host
// must set `window.idealStudioAllowedParentOrigins` (a single origin string,
// a comma-separated list, or an array of origin strings — e.g.
// "https://their-lms.example.com") BEFORE the editor bundle loads, the same
// way they set `window.idealStudioTrainingId` per STANDALONE_USAGE.md. If
// neither is configured, no parent origin is trusted (fail closed).
const getAllowedParentOrigins = () => {
  const configured = typeof window !== "undefined" ? window.idealStudioAllowedParentOrigins : null;
  const extra = Array.isArray(configured)
    ? configured
    : typeof configured === "string"
      ? configured
          .split(",")
          .map((o) => o.trim())
          .filter(Boolean)
      : [];
  return [process.env.APP_BASE_URL, ...extra].filter(Boolean);
};

export const isAllowedParentOrigin = (origin) => getAllowedParentOrigins().includes(origin);

// Fixed target origin for messages sent proactively to the host shell (no
// inbound event to reply to, so there is no event.origin to echo back).
// Returns null when no host origin is configured — callers should skip the
// send rather than fall back to "*".
export const getHostShellOrigin = () => process.env.APP_BASE_URL || null;
